import React from 'react';
import WithdrawalManagement from '../components/management/WithdrawalManagement';

const WithdrawalRecordsPage = () => {
    return (
        <div className="page-content">
            <WithdrawalManagement />
        </div>
    );
};

export default WithdrawalRecordsPage;
